import CustomerDrawer from '@/pages/customerAdmin/CustomerAdminDrawer.component'
import { createAttachmentTypesByCustomerQueryOptions, createAttachmentTypesCountQueryOptions } from '@/services/ticket/ticket.options'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_auth/customers/$customerId')({
  component: () => <CustomerDrawer />,
  params: {
    parse: (params) => ({
      customerId: z.number().int().parse(Number(params.customerId)),
    }),
    stringify: ({ customerId }) => ({ customerId: `${customerId}` }),
  },
  validateSearch: (search) => {
    return z
      .object({
        variant: z.enum(['edit', 'new']).default('edit'),
        title: z.string().default(''),
        // customerId: z.number().int().default(0),
      })
      .parse(search)
  },
  loader: async ({ params, context }) => {
    const attachmentTypes = context.queryClient.ensureQueryData(createAttachmentTypesByCustomerQueryOptions(params.customerId))
    const attachmentTypesCount = context.queryClient.ensureQueryData(createAttachmentTypesCountQueryOptions())
    return {
      attachmentTypes,
      attachmentTypesCount,
    }
  },
})
